import { useContext, useEffect, useRef } from "react";
import { QueueSocket } from "../../routes";
import { Box } from "@mui/material";

import { getSession } from "../../auth"
import ContentUnavailable from "../ContentUnavailable"
import CortexLogo from "../../assets/images/cortex-logo-horizontal.png"
import { useMenu } from "../../contexts/MenuContext"

const ConditionalRenderAssistant = ({ closeAssistant, page="chat", mode="sidebar" }) => {
    const { configurableUrls } = useMenu()

    if (! getSession().profile?.enterprise?.has_assistant || ! getSession().profile?.has_assistant) {
        return (
            <ContentUnavailable
                icon={
                    <img
                        src={CortexLogo}
                        alt="Cortex"
                        style={{ width: 350, margin: "-125px" }}
                    />
                }
                title={
                    !getSession().profile?.enterprise?.has_assistant
                        ? "Recurso indisponível para sua conta."
                        : "Recurso indisponível para seu usuário."
                }
                description={
                    !getSession().profile?.enterprise?.has_assistant ? (
                        <a
                            href={configurableUrls?.cortex ? configurableUrls.cortex : "https://cortex.instant.com.br"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Para mais informações sobre o Cortex, clique aqui.
                        </a>
                    ) : (
                        <span>
                            Entre em contato com seu administrador para ativar.
                        </span>
                    )
                }
            />
        )
    }

    const cortexDiv = useRef()
    const {cortexRef} = useContext(QueueSocket)

    // Written synchronously during render (not in an effect) so it's already
    // correct by the time React commits this update - which is when a
    // previous tab's componentWillUnmount (e.g. Chat's) may synchronously
    // call window.setExternalId() and need to know the *incoming* mode.
    // useEffect below runs only after commit/paint, too late for that race.
    window.assistantMode = mode

    useEffect(() => {
        if (cortexDiv?.current) {
            const cortexBody = cortexRef.current.firstChild
            cortexDiv.current.appendChild(cortexBody)
            window.closeAssistant = () => closeAssistant()
            if (typeof window.setCortexPage === "function")
                window.setCortexPage(page)
            if (typeof window.setAssistantMode === "function")
                window.setAssistantMode(mode)
            return () => {
                cortexRef.current.appendChild(cortexBody)
            }
        }
    }, [])

    return (
        <Box ref={cortexDiv} sx={{ height:"100%", zIndex:1000 }}></Box>
    )    
}

export default ConditionalRenderAssistant
